export default __webpack_public_path__ + "14567d0931b12e7c39e05b87c5f05e1e.png";